import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Award, XCircle } from "lucide-react";

export default function CertificateVerify() {
  const { code } = useParams();
  const [result, setResult] = useState(null);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/public/certificates/${code}`)
      .then((r) => setResult(r.data))
      .catch(() => setResult({ valid: false }));
  }, [code]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4" data-testid="certificate-verify-page">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg border border-slate-200 p-8 text-center">
        {!result ? (
          <div className="text-slate-400">Verificando…</div>
        ) : result.valid ? (
          <div data-testid="cert-valid">
            <Award className="h-14 w-14 text-emerald-500 mx-auto mb-4" />
            <h1 className="text-xl font-bold text-slate-900">Certificado válido ✓</h1>
            <p className="text-sm text-slate-500 mt-1">Emitido por We Speak Spanish CR</p>
            <div className="mt-6 space-y-2 text-left bg-slate-50 rounded-lg p-4 text-sm">
              <div><span className="text-slate-500">Estudiante: </span><span className="font-medium text-slate-900">{result.student_name}</span></div>
              <div><span className="text-slate-500">Curso: </span><span className="font-medium text-slate-900">{result.course_title}</span></div>
              <div><span className="text-slate-500">Fecha: </span><span className="font-medium text-slate-900">{result.issued_at?.slice(0, 10)}</span></div>
              <div><span className="text-slate-500">Código: </span><span className="font-mono text-slate-900">{result.code}</span></div>
            </div>
          </div>
        ) : (
          <div data-testid="cert-invalid">
            <XCircle className="h-14 w-14 text-red-400 mx-auto mb-4" />
            <h1 className="text-xl font-bold text-slate-900">Certificado no encontrado</h1>
            <p className="text-sm text-slate-500 mt-2">El código <span className="font-mono">{code}</span> no corresponde a ningún certificado emitido por We Speak Spanish CR.</p>
          </div>
        )}
      </div>
    </div>
  );
}
